import { render, staticRenderFns } from "./CMExamItem.vue?vue&type=template&id=5fb90b2e&scoped=true&lang=pug&"
import script from "./CMExamItem.vue?vue&type=script&lang=js&"
export * from "./CMExamItem.vue?vue&type=script&lang=js&"
import style0 from "./CMExamItem.vue?vue&type=style&index=0&id=5fb90b2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb90b2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
